import { call } from "../helpers/axiosInterceptor";


const getClasses = async () => {
    try {
        const { data } = await call.get("classes",
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("refToken"),
                }
            },);
        return data;
    } catch (e) {
        
    }
};


const getClassById = async (id) => {
    try {
        const { data } = await call.get(`classes/id/${id}`,
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("refToken"),
                }
            },);
        return data;
    } catch (e) {
        
    }
}

const createClass = async (classData) => {
    try {
        const res = await call.post(
            "classes/", // Assuming the endpoint is '/classes/'
            { data: classData }, // Wrapping classData in 'data' key to match your @Post() controller
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("refToken"),
                },
            }
        );
        return res.data; // Return the response data
    } catch (e) {
        console.error("Error creating class:", e);
        throw e; // Throw error to handle it in the calling code
    }
};

const updateClass = async (classId: string, classData: any) => {
    try {
        const res = await call.put(`classes/${classId}`,
            { data: classData },
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("refToken"),
                },
            }
        );
        return res.data;
    } catch (e) {
        console.error("Error updating class:", e);
        throw e;
    }
};

const deleteClass = async (classId: string) => {
    try {
        const res = await call.delete(
            `classes/${classId}`,
            {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("refToken"),
                },
            }
        );
        return res.data;
    } catch (e) {
        console.error("Error deleting class:", e);
        throw e;
    }
};

export { getClasses, createClass, updateClass, deleteClass, getClassById };